// extracted by mini-css-extract-plugin
module.exports = {"root":"e8Y3F","flyingSaucer":"_20Lxi","heading":"JlgbC","subHeading":"Cxy4C"};